export default {"src":"/_next/static/media/storage.1fbcf04a.svg","height":20,"width":20};